import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import * as getters from './getters'

Vue.use( Vuex );


const state = {
  productdata:{},
  login:false, //登錄狀態
  profiledata:{}, //使用者基本資料
  dailydata:{}, //每日
  userlog:{}, // 使用者點數使用歷史資料
  historylog:{}, // 使用者點數使用歷史資料
  purchaselog:{}, // 使用者點數使用歷史資料
  anaResult:{}, // 結果資料
  anaSubResult:{}, // 結果次層資料
  shopcart:{}, // 購物車資料
  plan:{}, // 消費方案
  orderpurchase:{}, //訂單資訊
  masterTips:{
    status:false,
    videostatus:false,
    videosrc:'',
    tipswords:'',
  },
  forgetdata:{}

}

//一個 module 僅可以有一個 default export。

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,

    // 嚴格模式，禁止直接修改 state
    strict: true
});

